import { getDBContentCollectionsWithAssociatedItems } from '../utils/collections';

import { CollectionTypes } from '~/types/adamTypes';

import { getServices } from '~/db/services';

import type { NomadDB } from '~/db/NomadDB';

import { tableHasLibraryBookIndex } from '~/db/utils';

export const dataClear = (db: NomadDB) => {
  const { importsService } = getServices(db);

  const clearForFreshInstallation = async (): Promise<any> => {
    const collections = Object.values(CollectionTypes);
    const promises = [];
    promises.push(importsService.clear());
    collections.forEach((collection) => {
      promises.push(db[collection].clear());
    });

    return Promise.all(promises);
  };

  const clearCollection = async (
    collection: CollectionTypes,
    forced: boolean = false
  ): Promise<void> => {
    if (!forced && tableHasLibraryBookIndex(db[collection])) {
      await db[collection].where({ libraryBookId: '' }).delete();
    } else {
      await db[collection].clear();
    }
    await importsService.deleteWhere({ collection, libraryBookId: '' });
  };

  const clearLibraryBook = async (libraryBookId) => {
    await importsService.deleteWhere({ libraryBookId });
    const collections = [];
    collections.forEach(async (collection) => {
      await db[collection].where({ libraryBookId }).delete();
    });
  };

  const clearLibraryBookCollection = async (
    libraryBookId: string,
    collection: CollectionTypes,
    source?: string
  ): Promise<void> => {
    await db.imports
      .where('[libraryBookId+collection]')
      .anyOf([libraryBookId, collection])
      .delete();
    if (collection === CollectionTypes.Media) {
      await db[collection]
        .where('[libraryBookId+source]')
        .anyOf([libraryBookId, source])
        .delete();
    } else {
      await db[collection].where({ libraryBookId }).delete();
    }
  };

  const clearLibraryBooks = async (libraryBookIds: string[]) => {
    await db.imports.where('libraryBookId').anyOf(libraryBookIds).delete();
    const collections = getDBContentCollectionsWithAssociatedItems();
    await Promise.all(
      collections.map(async (collection) => {
        await db[collection]
          .where('libraryBookId')
          .anyOf(libraryBookIds)
          .delete();
      })
    );
  };

  return {
    clearForFreshInstallation,
    clearLibraryBookCollection,
    clearLibraryBook,
    clearCollection,
    clearLibraryBooks,
  };
};
